import { render, staticRenderFns } from "./LinkmanItem.vue?vue&type=template&id=a3f5451e&scoped=true"
import script from "./LinkmanItem.vue?vue&type=script&lang=js"
export * from "./LinkmanItem.vue?vue&type=script&lang=js"
import style0 from "./LinkmanItem.vue?vue&type=style&index=0&id=a3f5451e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f5451e",
  null
  
)

export default component.exports